import asyncActionTypes from '../actions/types';

const initialState = {
  documentNumbers: [],
};

const refundPassengerList = (
  state = initialState,
  action = null / undefined
) => {
  switch (action.type) {
    case asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.START:
      return {
        documentNumbers: initialState.documentNumbers,
      };
    case asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.SUCCESS:
      return {
        documentNumbers: action?.payload,
      };
    case asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.FAIL:
      return {
        documentNumbers: initialState.documentNumbers,
      };
    default:
      return state;
  }
};

export default refundPassengerList;
